import { Stack, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";
import { ChatComposer } from "web_myplann/Chat/Components/ChatComposer";
import { ChatEmptyState } from "web_myplann/Chat/Components/ChatEmptyState";
import { ChatHeader } from "web_myplann/Chat/Components/ChatHeader";
import { ChatMessageList } from "web_myplann/Chat/Components/ChatMessageList";
import { ChatSkeleton } from "web_myplann/Chat/Components/ChatSkeleton";
import { useChatPage } from "web_myplann/Chat/Hooks/useChatPage";

export const ChatPage = () => {
	const theme = useTheme();
	const scrollRef = useRef<HTMLDivElement>(null);
	const lastNewestIdRef = useRef<number | null>(null);
	const {
		advisorName,
		advisorPhoto,
		messages,
		isLoading,
		hasOlder,
		isLoadingOlder,
		loadOlder,
		input,
		setInput,
		onSend,
		isSending,
		onPickPhoto,
		onPickGallery,
		onPickFile,
		onBack,
	} = useChatPage();

	useEffect(() => {
		if (messages.length === 0) return;
		const newest = messages.reduce((latest, message) =>
			message.createdAt > latest.createdAt ? message : latest,
		);
		if (newest.id === lastNewestIdRef.current) return;
		lastNewestIdRef.current = newest.id;
		if (scrollRef.current) {
			scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
		}
	}, [messages]);

	const hasMessages = messages.length > 0;

	return (
		<Stack height="100dvh" bgcolor={theme.palette.background.paper}>
			<ChatHeader name={advisorName} photo={advisorPhoto} onBack={onBack} />

			<Stack
				ref={scrollRef}
				flex={1}
				minHeight={0}
				px={1.2}
				py={1.2}
				bgcolor={theme.palette.surface.muted}
				sx={{ overflowY: "auto" }}
			>
				{isLoading ? (
					<ChatSkeleton />
				) : hasMessages ? (
					<ChatMessageList
						messages={messages}
						advisorName={advisorName}
						advisorPhoto={advisorPhoto}
						hasOlder={hasOlder}
						isLoadingOlder={isLoadingOlder}
						onLoadOlder={loadOlder}
					/>
				) : (
					<ChatEmptyState />
				)}
			</Stack>

			<ChatComposer
				value={input}
				onChange={setInput}
				onSend={onSend}
				onPickPhoto={onPickPhoto}
				onPickGallery={onPickGallery}
				onPickFile={onPickFile}
				disabled={isSending}
			/>
		</Stack>
	);
};
